import { render, staticRenderFns } from "./CustomerFieldEdit.vue?vue&type=template&id=e5f5a0be"
import script from "./CustomerFieldEdit.vue?vue&type=script&lang=js"
export * from "./CustomerFieldEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports